<template>
    <b-container class="bv-example-row">
        <b-row class="text-center " >
            <b-col md="8" offset-md="2">
                <div class="border rounded py-4 px-5">
                    <h3 class="font-weight-bold text-left">Sign up </h3>
                     <p class="text-left">Create 
                         <span class="orang-color">company</span> 
                         account </p>
                    <b-form  class="text-left" >
                        <b-form-group id="input-group-name ">
                            <div class="box-img-m mb-3 mx-auto" >
                                <div class="d-flex justify-content-center align-items-center" v-if="profileName == ''">
                                    170 X 170
                                </div>
                                <div v-else class="d-flex justify-content-center align-items-center">
                                    <img class="mw-100" :src="pathImg+profileName">
                                </div>
                            </div>
                        <div class="mt-3 position-relative text-center">
                            <b-form-file v-model="profilePic" class="position-absolute file-upload" plain @change="checkProfile($event)"></b-form-file>
                            <i class="fas fa-file-upload"></i> {{ profileName ? profileName : 'No file chosen' }}
                        </div>
                        </b-form-group>

                        <b-form-group id="input-group-name" label="Name"  label-for="input-name">
                            <b-form-input
                                v-model="name"
                                name="name"
                                id="input-name"
                                :class="{'is-invalid':errors.has('name')}"
                                type="text"
                                v-validate="'required'"
                                placeholder="Name"
                            ></b-form-input>
                            <div v-show="errors.has('name')" class="invalid-feedback">
                                Please name a valid state.
                            </div>
                        </b-form-group>

                        <b-form-group id="input-group-surename" label="Surename" label-for="input-surename">
                            <b-form-input
                                v-model="surname"
                                name="surename"
                                id="input-surename"
                                :class="{'is-invalid':errors.has('surename')}"
                                v-validate="'required'"
                                placeholder="Surename"
                            ></b-form-input>
                            <div v-show="errors.has('surename')" class="invalid-feedback">
                                Please surename a valid state.
                            </div>
                        </b-form-group>
                       
                        <b-form-group id="input-group-2" label="Email" label-for="input-email">
                            <b-form-input
                                v-model="email"
                                name="email"
                                id="input-email"
                                :class="{'is-invalid':errors.has('email')}"
                                v-validate="'email|required'"
                                placeholder="Email"
                            ></b-form-input>
                            <div v-show="errors.has('email')" class="invalid-feedback">
                                Please email a valid state.
                            </div>
                        </b-form-group>

                        <b-form-group id="input-group-2" label="Password" label-for="input-password">
                            <b-form-input
                                v-model="password"
                                name="password"
                                type="password"
                                v-validate="'required'"
                                id="input-password"
                                :class="{'is-invalid':errors.has('password')}" 
                                placeholder="Password"
                                ref="password"
                            ></b-form-input>
                            <div v-show="errors.has('password')" class="invalid-feedback">
                                Please Password a valid state.
                            </div>
                        </b-form-group>

                        <b-form-group id="input-group-confirm-password" label="Confirm password" label-for="input-confirm-password">
                            <b-form-input
                                v-model="confirmPassword"
                                name="confirmPassword"
                                type="password"
                                v-validate="'required|confirmed:password'"
                                id="input-confirm-password"
                                :class="{'is-invalid':errors.has('confirmPassword')}"
                                required
                                placeholder="Confirm password"
                            ></b-form-input>
                            <div v-show="errors.has('confirmPassword')" class="invalid-feedback">
                                Your password and confirmation password do not match.
                            </div>
                        </b-form-group>

                        <b-form-checkbox class="mb-4" v-model="checkTermCon">By clicking this form you agree with our <span class="orang-color">Terms and Conditions.</span></b-form-checkbox>
                        <b-button 
                            @click="signin"
                            block 
                            pill 
                            variant="outline-primary" 
                            class="btn-sigin bg-company not-shadow-active my-3">
                            SIGN UP</b-button>
                    </b-form>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import {HTTPTICKET} from "@/axios.js";
import axios from "axios";
import Swal from 'sweetalert2'

export default {
    name: 'Signin',
    data () {
        return {
            pathImg:process.env.VUE_APP_IMG_PROFILE_TICKET,
            name: null,
            surname : null,
            email : null,
            email: null,
            password:null,
            confirmPassword:null,
            checkTermCon:false,
            profileupload:0,
            profilePic:[],
            profileName:''
        }
    },
    methods:{
        checkProfile(event) {
          console.log('this.profilePic',event.target.files[0])
          this.profileupload = 2;
            const profile = new FormData();
            profile.append('file', event.target.files[0]);
            const config = {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            };
            HTTPTICKET.post('/upload/profile', profile, config).then((result) => {
              this.profileName = result.data.obj;
              if (result.data !== '') {
                this.profileupload = 1;
              } else {
                this.profileupload = 0;
              }
            });

        },
       signin(){
            this.$validator.validate().then(valid => {
                if (valid) {
                    if (this.checkTermCon !== false) {
                        let obj={
                            name: this.name,
                            surname : this.surname,
                            userLevel:1,
                            email : this.email,
                            password: this.password,
                            profilePic: this.profileName
                        }
                        HTTPTICKET.post('/api/sign/up',obj).then(res => {
                            console.log('/api/sign/up',res.data)
                            if (res.data.success) {
                               
                                this.$router.push('/')
                            }else{
                                Swal.fire(
                            'Error',
                            res.data.data,
                            'error'
                            )
                            }
                        }).catch(e => {  
                            console.log("/api/sign/up/error",e);
                        });
                    }else{
                        Swal.fire(
                        'Error',
                        'กรุณากดยอมรับเงื่อนไขการใช้งานระบบ',
                        'error'
                        )
                    }

                }
            })
       }
    },
}

</script>
<style  scoped>

    .file-upload{
        opacity: 0;
    }
    .btn-sigin{
        min-height: 45px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue